"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var react_final_form_1 = require("react-final-form");
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var downloads_1 = require("utils/hooks/downloads");
var GetLineItemsModal = function (_a) {
    var onClose = _a.onClose, company = _a.company, service = _a.service, open = _a.open;
    var mainName = (company === null || company === void 0 ? void 0 : company.name) || (service === null || service === void 0 ? void 0 : service.niceName) || (service === null || service === void 0 ? void 0 : service.name);
    var _b = __read((0, downloads_1.useDownloadFromBackend)('transactions-getLineItemsCsv', "lineItemsFor_".concat(mainName)), 1), getLineItemsCsv = _b[0];
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: open, onClose: onClose }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ mb: 1, level: 3 }, { children: ["Get Line Items for ", mainName] })) }), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function (values) { return getLineItemsCsv((0, pickBy_1.default)(values)).then(onClose); }, initialValues: { companyId: company === null || company === void 0 ? void 0 : company.id, serviceId: service === null || service === void 0 ? void 0 : service.id } }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [!company && (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "companyId" }), !service && (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "serviceId" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "contactName" })] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: handleSubmit, isSending: submitting }, { children: "Get CSV" })) })] }));
                } }))] })));
};
exports.default = GetLineItemsModal;
